export const nlgDemo = 'https://nlg-demo.retresco.de';
